import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

// Fixed Asset Categories
export const getCategories = async () => {
  const response = await axios.get(`${API_URL}/fixed-assets/categories`, getAuthHeaders());
  return response.data;
};

export const getCategoryById = async (id) => {
  const response = await axios.get(`${API_URL}/fixed-assets/categories/${id}`, getAuthHeaders());
  return response.data;
};

export const createCategory = async (data) => {
  const response = await axios.post(`${API_URL}/fixed-assets/categories`, data, getAuthHeaders());
  return response.data;
};

export const updateCategory = async (id, data) => {
  const response = await axios.put(`${API_URL}/fixed-assets/categories/${id}`, data, getAuthHeaders());
  return response.data;
};

export const deleteCategory = async (id) => {
  const response = await axios.delete(`${API_URL}/fixed-assets/categories/${id}`, getAuthHeaders());
  return response.data;
};

// Fixed Assets
export const getAssets = async () => {
  const response = await axios.get(`${API_URL}/fixed-assets`, getAuthHeaders());
  return response.data;
};

export const getAssetById = async (id) => {
  const response = await axios.get(`${API_URL}/fixed-assets/${id}`, getAuthHeaders());
  return response.data;
};

export const createAsset = async (data) => {
  const response = await axios.post(`${API_URL}/fixed-assets`, data, getAuthHeaders());
  return response.data;
};

export const updateAsset = async (id, data) => {
  const response = await axios.put(`${API_URL}/fixed-assets/${id}`, data, getAuthHeaders());
  return response.data;
};

export const deleteAsset = async (id) => {
  const response = await axios.delete(`${API_URL}/fixed-assets/${id}`, getAuthHeaders());
  return response.data;
};

export const runDepreciation = async (id, data) => {
  const response = await axios.post(`${API_URL}/fixed-assets/${id}/depreciate`, data, getAuthHeaders());
  return response.data;
};
